
import { Logo } from "@/components/shared/Logo";
import { useNavigate } from "react-router-dom";

export const AuthHero = () => {
  const navigate = useNavigate();
  
  const handleLogoClick = () => {
    navigate('/');
  };
  
  return (
    <div className="w-full md:w-1/2 relative">
      <div className="h-full">
        <img 
          src="https://bikusyozqktomenrosbg.supabase.co/storage/v1/object/public/app-assets//Hero-Image.webp"
          alt="Hero"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/30 flex items-center justify-center">
          <div 
            onClick={handleLogoClick} 
            className="z-10 cursor-pointer transition-transform hover:scale-105 text-center"
          >
            <Logo variant="landing" />
          </div>
        </div>
      </div>
    </div>
  );
};
